import styled from 'styled-components';
import { BreadcrumbsStyled } from '../BreadcrumbsStyled';

export const BreadcrumbsAC = styled(BreadcrumbsStyled)`
    a {
        color: ${({ theme }) => theme.colors.orange1};

        &:hover {
            color: ${({ theme }) => theme.colors.brown5};
        }
    }
    span,
    a {
        ::before {
            color: ${({ theme }) => theme.colors.secondary};
            content: '/';
        }
    }
`;
